import axios from "axios";
import {
  login as loginApi,
  checkSession as checkSessionApi,
  bootstrap as bootstrapApi,
  signOut as signOutApi,
} from "app/api/auth.api";
import { setSession, setUserInfo, setAccessRights, clearSession, setSessionChecked, setLoading, setError } from "./session.slice";

export const loginUser = ({ email, password }) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await loginApi({ email, password });
    const data = response.data.data || response.data;

    const accessToken = data.access_token;
    const sessionId = data.session_id;
    const sessionExpiration = data.session_expiration;
    const tokenPayload = data.access_token_payload || {};

    // Store in localStorage
    localStorage.setItem("admin_access_token", accessToken);
    localStorage.setItem("admin_session_id", sessionId);
    localStorage.setItem("admin_session_expiration", sessionExpiration);

    // Set axios auth header
    axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

    // Set session in Redux
    dispatch(setSession({
      token: accessToken,
      user: {
        name: tokenPayload.name || "",
        email: tokenPayload.email || "",
        sub: tokenPayload.sub || "",
      },
    }));

    // Fetch bootstrap data (user info + access rights)
    await dispatch(fetchBootstrap());

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || "Login failed";
    dispatch(setError(message));
    return { success: false, message };
  }
};

export const fetchBootstrap = () => async (dispatch) => {
  try {
    const response = await bootstrapApi();
    const data = response.data.data || response.data;
    dispatch(setUserInfo({
      name: data.name || "",
      roleName: data.role_name || "",
    }));
    dispatch(setAccessRights(data.access_right || data.access_rights || []));
  } catch (error) {
    // Bootstrap failure is not fatal - user is still logged in
  }
};

export const checkSession = () => async (dispatch) => {
  const token = localStorage.getItem("admin_access_token");
  const sessionId = localStorage.getItem("admin_session_id");
  const sessionExpiration = localStorage.getItem("admin_session_expiration");

  if (!token || !sessionId || !sessionExpiration) {
    dispatch(setSessionChecked());
    return;
  }

  try {
    // Validate session with backend
    await checkSessionApi({ sessionId, sessionExpiration });

    // Session is valid - restore it
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    dispatch(setSession({ token, user: null }));

    // Fetch user info and access rights
    await dispatch(fetchBootstrap());
  } catch (error) {
    // Session invalid - clear everything
    localStorage.removeItem("admin_access_token");
    localStorage.removeItem("admin_session_id");
    localStorage.removeItem("admin_session_expiration");
    dispatch(setSessionChecked());
  }
};

export const logout = () => async (dispatch) => {
  const sessionId = localStorage.getItem("admin_session_id");
  const sessionExpiration = localStorage.getItem("admin_session_expiration");

  try {
    if (sessionId && sessionExpiration) {
      await signOutApi({ sessionId, sessionExpiration });
    }
  } catch (error) {
    // Sign-out failure is not fatal
  }

  localStorage.removeItem("admin_access_token");
  localStorage.removeItem("admin_session_id");
  localStorage.removeItem("admin_session_expiration");
  delete axios.defaults.headers.common["Authorization"];
  dispatch(clearSession());
};
